import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { MethodSteps } from "../components/MethodSteps";
import { VideoTutorial } from "../components/VideoTutorial";
import { ContactFooter } from "../components/ContactFooter";
import { AssistantWidget } from "../components/AssistantWidget";
import { useLanguage } from "../i18n";

const VIDEO_RATE = 0.75;
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MethodPage() {
  const { t } = useLanguage();
  const m = t.methodPage;
  const videoRef = useRef(null);
  const [examples, setExamples] = useState({});
  // The two example books live in Progetti; find them by title so the links survive re-uploads
  useEffect(() => {
    fetch(`${API}/portfolio`).then((r) => r.json()).then((items) => {
      const ex = (items || []).filter((x) => x.kind === "example");
      const find = (re) => (ex.find((x) => re.test(x.title || "")) || {}).id;
      setExamples({ concept: find(/lighting concept/i), exec: find(/consulenza esecutiva/i) });
    }).catch(() => {});
  }, []);
  useEffect(() => { window.scrollTo(0, 0); }, []);
  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = true;
    v.playbackRate = VIDEO_RATE;
    v.play().catch(() => {});
  }, []);
  return (
    <div data-testid="method-page" className="min-h-screen bg-cream">
      <Header />
      <main>
        <section data-testid="method-heading" className="mt-14 pt-14 lg:pt-16 pb-10 lg:pb-12 bg-sand">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-inksoft">
              <Link to="/" className="hover:text-ink">Home</Link> · {t.nav.method}
            </p>
            <h1 data-testid="method-title" className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-ink">{m.title}</h1>
            {m.subtitle && <p data-testid="method-subtitle" className="mt-3 max-w-md text-sm leading-relaxed text-inksoft">{m.subtitle}</p>}
          </div>
        </section>
        {/* The studio's video (slowed down), full width under the heading; the title stays in the heading above */}
        <section data-testid="method-banner" style={{ "--banner-ratio": "16 / 9" }} className="day-light-bg group relative banner-full overflow-hidden bg-black">
          <video ref={videoRef} data-testid="method-video" src="/media/metodo-video.mp4" autoPlay muted loop playsInline onLoadedMetadata={(e) => { e.currentTarget.playbackRate = VIDEO_RATE; }} className="bw-hover absolute inset-0 w-full h-full object-cover" />
        </section>
        <section data-testid="method-intro" className="py-20 lg:py-24 bg-sand">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-12">
            <div className="lg:col-start-6 lg:col-span-6">
              <p className="font-mono text-[11px] uppercase tracking-[0.15em] text-inksoft mb-5">{m.introLabel}</p>
              <p className="text-xl leading-relaxed text-ink">{m.intro}</p>
              <div data-testid="method-example-buttons" className="mt-8 flex flex-wrap gap-3">
                <Link data-testid="method-example-concept" to={examples.concept ? `/progetti/${examples.concept}` : "/progetti"} className="inline-flex items-center border border-ink/30 hover:border-ink text-ink rounded-sm px-5 h-11 font-mono text-[11px] uppercase tracking-[0.12em]">{m.exampleConcept}</Link>
                <Link data-testid="method-example-exec" to={examples.exec ? `/progetti/${examples.exec}` : "/progetti"} className="inline-flex items-center border border-ink/30 hover:border-ink text-ink rounded-sm px-5 h-11 font-mono text-[11px] uppercase tracking-[0.12em]">{m.exampleExec}</Link>
              </div>
            </div>
          </div>
        </section>
        <MethodSteps />
        <VideoTutorial />
      </main>
      <ContactFooter clearWidget />
      <AssistantWidget />
    </div>
  );
}
